import { EditorMovePageButton } from './EditorMovePageButton.tsx';

export const EditorMovePageButtonLoader = EditorMovePageButton;
